<template>
  <a-modal
    :wrapClassName="disabled ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="基地名称" prop="baseName">
          <a-input v-model="form.baseName" :disabled="disabled" />
        </a-form-model-item>
        <a-form-model-item label="基地形式" prop="baseForm">
          <a-select v-model="form.baseForm" :disabled="disabled">
            <a-select-option
              :value="item.value"
              v-for="item in jdlblist"
              :key="item.value"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="基地类别" prop="baseType">
          <a-select v-model="form.baseType" :disabled="disabled">
            <a-select-option
              :value="item.value"
              v-for="item in jdxslist"
              :key="item.value"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="加入时间" prop="cooperativeTime">
          <a-date-picker
            placeholder="请选择加入时间"
            v-model="form.cooperativeTime"
            :format="'YYYY-MM-DD'"
            :locale="locale"
            class="form-item-right"
            :disabled="disabled"
          />
        </a-form-model-item>
        <a-form-model-item label="合作单位" prop="company">
          <div class="flex">
            <a-select v-model="form.company" :disabled="disabled">
              <a-select-option
                :value="item.text"
                v-for="item in hzdwlist"
                :key="item.text"
                >{{ item.title }}</a-select-option
              >
              <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
            </a-select>
            <template v-if="form.company == '其他'">
              <a-input
                v-model="form.otherCompany"
                class="ipt-other"
                :disabled="disabled"
              />
            </template>
          </div>
        </a-form-model-item>
        <a-form-model-item label="育人功能关键词" prop="keyWords1">
          <a-select
            mode="tags"
            style="width: 100%"
            v-model="form.keyWords1"
            placeholder="请选择育人功能关键词"
            @change="handleChangezh"
            :disabled="disabled"
          >
            <a-select-option v-for="item in kcList" :value="item.name">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        baseName: "",
        cooperativeTime: "",
        baseForm: "",
        amount: "",
        levelType: "",
        baseType: "",
        courseType: "",
        otherLevelType: "",
        cooperative_time: "",
        company: "",
        otherCompany: "",
        keyWords1: [],
        keyWords: "",
      },
      hzdwlist: [],
      kcList: [],

      disabled: false,
      rules: {
        baseName: [
          {
            required: true,
            message: "请输入基地名称",
            trigger: "blur",
          },
        ],
        baseForm: [
          {
            required: true,
            message: "请选择基地形式",
            trigger: "change",
          },
        ],
        baseType: [
          {
            required: true,
            message: "请选择基地类别",
            trigger: "change",
          },
        ],
        cooperativeTime: [
          {
            required: true,
            message: "请选择加入时间",
            //          type: 'string',
            trigger: "blur",
          },
        ],
        company: [
          {
            required: true,
            message: "请选择合作单位",
            //          type: 'string',
            trigger: "change",
          },
        ],
        keyWords1: [
          {
            required: true,
            message: "请选择育人功能关键词",
            trigger: "change",
          },
        ],
        // levelType: [
        //   {
        //     required: true,
        //     message: "请输入级别",
        //     trigger: "change",
        //   },
        // ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jdxslist: [],
      jdlb: [],
      ishow: false,
      ifirst: true,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
  },
  methods: {
    handleChangezh() {
      if (this.form.keyWords1.length > 0) {
        let keyWords1 = this.form.keyWords1;
        this.form.keyWords = keyWords1.join(",");
      } else {
        this.form.keyWords = "";
      }
      this.$forceUpdate();
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleChange() {
      console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      this.form.acquireYear = value;
      this.$refs.ruleForm.clearValidate("acquireYear");
      this.yearShowOne = false;
    },
    getkcList() {
      getAction("/lxbase/lxFuncKeywords/allList", {}).then((res) => {
        console.log(res, "66666");
        if (res.code == 200) {
          console.log(res, "66666");
          this.kcList = res.result;
        }
      });
    },
    gethzdwlist() {
      getAction("/baseCommon/getDictItemsByCode?code=sz_company").then(
        (res) => {
          if (res.code == 200) {
            this.hzdwlist = res.result;
          }
        }
      );
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.disabled = false;
      this.getjdxslist();
      this.getjdlblist();
      this.gethzdwlist();
      this.getkcList();
      console.log(type, "44444");
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.title = "新增基地";
      } else if (type === "audit-edit") {
        this.title = "编辑基地";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          title: record.title,
          achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          cooperativeTime: record.cooperativeTime,
          baseForm: record.baseForm,
          baseType: record.baseType,
          baseName: record.baseName,
          company: record.company,
          otherCompany: record.otherCompany,
          keyWords: record.keyWords,
        };
        if (record.keyWords != "") {
          let keyWords = record.keyWords;
          this.form.keyWords1 = keyWords.split(",");
        }
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      } else if (type == "see") {
        this.title = "查看基地";
        this.disabled = true;
        this.saveText = "关闭";
        this.form = {
          title: record.title,
          achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          cooperativeTime: record.cooperativeTime,
          baseForm: record.baseForm,
          baseType: record.baseType,
          baseName: record.baseName,
          company: record.company,
          otherCompany: record.otherCompany,
          keyWords: record.keyWords,
        };
        if (record.keyWords != "") {
          let keyWords = record.keyWords;
          this.form.keyWords1 = keyWords.split(",");
        }
      } else {
        this.title = "编辑基地";
        this.form = {
          title: record.title,
          achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          cooperativeTime: record.cooperativeTime,
          baseForm: record.baseForm,
          baseType: record.baseType,
          baseName: record.baseName,
          company: record.company,
          otherCompany: record.otherCompany ? record.otherCompany : "",
          keyWords: record.keyWords,
        };
        if (record.keyWords && record.keyWords != "") {
          let keyWords = record.keyWords;
          this.form.keyWords1 = keyWords.split(",");
        }
        this.teacherdata = record;
        console.log(this.teacherdata);
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getjdxslist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=base_type").then((res) => {
        if (res.code == 200) {
          this.jdxslist = res.result;
        }
      });
    },
    getcgjb() {
      // this.jblist = [
      //   {
      //     value: "国家级",
      //     title: "国家级",
      //   },
      //   {
      //     value: "省级",
      //     title: "省级",
      //   },
      //   {
      //     value: "市级",
      //     title: "市级",
      //   },
      //   {
      //     value: "县级",
      //     title: "县级",
      //   },
      //   {
      //     value: "校级",
      //     title: "校级",
      //   },
      //   {
      //     value: "其他",
      //     title: "其他",
      //   },
      // ];
      // getAction("/baseCommon/getDictItemsByCode?code=base_type",).then((res) => {
      // 	if (res.code == 200) {
      // 		this.jblist=res.result;
      // 	}
      // });
    },
    getjdlblist() {
      getAction("/baseCommon/getDictItemsByCode?code=base_form").then((res) => {
        if (res.code == 200) {
          this.jdlblist = res.result;
        }
      });
    },
    submit() {
      if (this.disabled) {
        this.visible = false;
        return false;
      }
      //  	this.$refs.ruleForm.clearValidate();
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != ""
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            //          params.acquireYear=new Date(this.form.acquireYear).getFullYear()+"";
            params.applyType = this.applyType;
            //params.applyId = "1829722136428707841";
            postAction("/lxbase/lxApplyCooperativeBase/add", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("添加成功");
                  this.$emit("addBase");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addBase");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            console.log(this.teacherdata);
            if (
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.acquireYear == "object") {
                params1.acquireYear =
                  new Date(this.form.acquireYear).getFullYear() + "";
              }
              params1.applyType = this.applyType;
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addBase");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.acquireYear == "object") {
                params.acquireYear =
                  new Date(this.form.acquireYear).getFullYear() + "";
              }
              params.applyType = this.applyType;
              putAction("/lxbase/lxApplyCooperativeBase/edit", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addBase");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>